/**
 * 3D めくりの見た目を決める定数。
 * 値は dflip 実機の既定（観察による — コードは移植していない）に合わせ、
 * 「並置比較で見た目同等」（設計書 M3 verify・P-2）を狙う。
 */

/** めくりの所要時間（ms）。 */
export const FLIP_MS = 800;

/** 紙の撓みやすさ（0 = 硬い板・撓まない）。 */
export const FLEX = 0.9;

/** シートの横方向分割数（撓み曲線のサンプル数）。 */
export const SEGMENTS = 50;

/** 透視投影の画角（度）。望遠寄りにして遠近の歪みを抑える。 */
export const FOV_DEG = 20;

// 描画倍率の上限・テクスチャ近傍幅・領域ラスタの待ち時間は css2d と共有する
// （エンジンで挙動が食い違わないよう、値の定義点は engine/constants.ts 1 か所）。
export { DETAIL_DELAY_MS, DETAIL_MIN_ZOOM, MAX_DPR, WINDOW_PAGES } from '../constants';

/**
 * めくり中の描画倍率（静止時に対する比）。
 * 3D の負荷は塗りつぶし面積でほぼ決まるため、動いている間だけ解像度を落とすと
 * 弱い GPU でもフレームレートを保てる。止まった瞬間に元の解像度で描き直す。
 */
export const FLIP_RENDER_SCALE = 0.75;

/** テクスチャ幅の上限（px）。端末の maxTextureSize とも比較して小さい方を使う。 */
export const MAX_TEXTURE = 3200;

/**
 * 環境光・平行光の強さ。
 * three r155 以降のライティングは物理量として扱われ、Lambert 反射の 1/π が掛かる。
 * dflip（r148・旧ライティング）の 0.8 / 0.22 と同じ明るさにするには π 倍が必要。
 */
export const AMBIENT_INTENSITY = 0.8 * Math.PI;
export const DIRECTIONAL_INTENSITY = 0.22 * Math.PI;

/**
 * めくり中のシートが落とす影の濃さと、影マップの解像度。
 * 影はページ自身ではなく専用の受け面（ShadowMaterial）で受けるため、この値が
 * そのまま影の濃さになる（ページの明るさには影響しない）。
 */
export const SHADOW_OPACITY = 0.32;
export const SHADOW_MAP_SIZE = 1024;

/** 影の受け面をページのどれだけ手前に置くか（z ファイティング回避）。 */
export const SHADOW_PLANE_Z = 0.5;

/** 詳細面（拡大時の領域ラスタ）を置く高さ。ページ（0）と影の受け面（0.5）の間。 */
export const DETAIL_PLANE_Z = 0.05;

